import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  Tooltip
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SelectInput } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%'
  },
  closeIcon: {
    margin: '5px',
    cursor: 'pointer'
  },
  cardActions: {
    flexDirection: 'row-reverse'
  },
  inputGrid: {
    maxWidth: '40rem'
  }
}));

const Details = props => {
  const { className, staticContext, schema, next, showNav, ...rest } = props;
  const schemaDetails = useSelector(
    store => store.enrichedSchema.currentDetails
  );
  const classes = useStyles();
  const {
    isLoading,
    goNext,
    handleChange,
    onFocus,
    handleBlur,
    shouldShowError,
    getErrorMessage,
    updateCurrentErrorValidationSegment,
    handleOptionsChange,
    closeSchema,
    enrichmentProducts
  } = schema;

  useEffect(() => {
    updateCurrentErrorValidationSegment('details');
  }, []);

  const productOptions = {
    list: enrichmentProducts,
    keyId: 'option',
    valueId: 'option',
    displayValueId: 'option'
  };

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <div className={classes.headerContainer}>
            <div className={classes.title}>
              <CardHeader
                subheader="* indicates a required field"
                title="Enriched Schema Details"
                titleTypographyProps={{ variant: 'h1' }}
              />
            </div>
            <div className={classes.closeIcon}>
              <Tooltip title="Close" arrow>
                <CloseIcon
                  style={{ marginTop: '16px' }}
                  onClick={closeSchema}
                  color="error"
                />
              </Tooltip>
            </div>
          </div>
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Grid item xs={12} className={classes.inputGrid}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    required
                    margin="dense"
                    name="name"
                    label="Enriched Schema Name"
                    value={schemaDetails.name || ''}
                    onChange={handleChange}
                    onFocus={onFocus}
                    onBlur={handleBlur}
                    error={shouldShowError('name')}
                    helperText={getErrorMessage('name')}
                  />
                </Grid>
                {enrichmentProducts && (
                  <Grid item xs={12} className={classes.inputGrid}>
                    <SelectInput
                      fullWidth
                      required
                      margin="dense"
                      name="enrichmentProduct"
                      label="Enrichment Product"
                      value={schemaDetails.option || ''}
                      disabled={schemaDetails.hasMovedToNextStep}
                      onBlur={handleBlur}
                      onChange={handleOptionsChange}
                      error={shouldShowError('option')}
                      helperText={getErrorMessage('option')}
                      options={productOptions}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </CardContent>
          <>
            <Divider />
            <CardActions className={classes.cardActions}>
              <Button
                color="primary"
                variant="contained"
                disabled={isLoading}
                link={next}
                onClick={goNext}>
                Next
              </Button>
            </CardActions>
          </>
        </form>
      </Card>
    </div>
  );
};

export default Details;
